import { render } from "./FaqsSection.vue?vue&type=template&id=6a1686d3&scoped=true"
import script from "./FaqsSection.vue?vue&type=script&lang=js"
export * from "./FaqsSection.vue?vue&type=script&lang=js"

import "./FaqsSection.vue?vue&type=style&index=0&id=6a1686d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1686d3"]])

export default __exports__